export const REQUEST_STATUS = {
    NOT_REQUESTED: 'NOT_REQUESTED',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
export const COLLAPSED_SIDEBAR_WIDTH = 68;
export const EXPANDED_SIDEBAR_WIDTH = 220;

export const dateFormat = 'HH:mm DD MMM YYYY';
export const dateFormatWithoutHours = 'DD MMM YYYY';
export const expiresDateTimeFormat = 'MMM D, HH:mm';
export const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export const utmsButtonSx = {
    fontWeight: 600,
    fontSize: '0.875rem',
    flexShrink: 0,
    letterSpacing: 0.4,
    whiteSpace: 'nowrap',
};

export const DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
